// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useQuery from "hooks/useQuery";

// #####################################################

const useHeightFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	const query = useQuery();

	const { height_from: heightMinUrl, height_to: heightMaxUrl } = query || {};

	// ** Filtr - Wzrost
	const heightFilterData = useMemo(() => {
		const minHeightFilterValue = heightMinUrl
			? `${t("common:from")} ${heightMinUrl}`
			: "";
		const maxHeightFilterValue = heightMaxUrl
			? `${t("common:to")} ${heightMaxUrl}`
			: "";
		return minHeightFilterValue || maxHeightFilterValue
			? {
					label: t("filtersAndSelectors:height"),
					selected:
						[minHeightFilterValue, maxHeightFilterValue]
							.filter((x) => Boolean(x))
							.join(" ") +
						" " +
						t("common:cm"),
			  }
			: null;
	}, [heightMinUrl, heightMaxUrl, language]);

	// #####################################################

	return heightFilterData;
};

// #####################################################

export default useHeightFilterData;

// #####################################################
